import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useFilterStore } from '../store/filter-store';
import { Switch } from '@/components/ui/Switch';
import type { Operator } from '@/features/location/types/location-info.types';

interface OperatorFilterProps {
  operators: Operator[];
  isLoading?: boolean;
}

/**
 * Operator filter section
 */
export function OperatorFilter({ operators, isLoading }: OperatorFilterProps) {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const selectedOperatorSuggestionIds = useFilterStore(
    (s) => s.selectedOperatorSuggestionIds
  );
  const toggleOperatorSuggestion = useFilterStore(
    (s) => s.toggleOperatorSuggestion
  );

  // Hide operator filter when operator_scope=restrict
  const operatorScope = searchParams.get('operator_scope');
  if (operatorScope === 'restrict') {
    return null;
  }

  return (
    <div className="space-y-3 pt-3 pb-2">
      {isLoading ? (
        <div className="flex items-center justify-center py-4">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-4 border-ink border-t-transparent" />
        </div>
      ) : operators.length === 0 ? (
        <p className="text-sm text-muted">
          {t('filters.operators.noOperators')}
        </p>
      ) : (
        operators.map((operator) => (
          <Switch
            key={operator.id}
            checked={selectedOperatorSuggestionIds.includes(operator.id)}
            onCheckedChange={() => toggleOperatorSuggestion(operator)}
            label={operator.name}
          />
        ))
      )}
    </div>
  );
}
